<template>
    <div class="tree" id="tree-protocol"></div>
</template>

<script>
    import {
        go,
        goMake,
        makePanel,
        makeTextBlock,
        makeExpanderButton,
        setCommitNodes,
        linkTemplate
    } from '@mixins/protocolTemplate.js'

    go.Diagram.licenseKey = "73f944eab16131b700ca0d2b113f69ef1bb37f3b9ed71ba75e5146f1ea5c6d173089ef7a01d58bc181a81aab182dc28ad4956c2a9f19016be031d78c44b284fae13161a2125d1788a45176c28bea29a0ff7a6ef2ddb1";

    export default {
        props: {
            Data: {
                type: Array, default: function () {
                    return []
                }
            },
        },
        data() {
            return {
                diagram: null,
                selectProtocol: null
            }
        },
        watch: {
            Data(data) {
                if (data.constructor !== Array) {
                    if (data.issues) data = data.issues;
                    else data = []
                }
                this.setModel(data);
            }
        },
        async mounted() {
            this.initDiagram();
            if (this.Data != null && this.Data.length > 0) {
                this.setModel(this.Data);
            }
        },
        methods: {
            initDiagram() {
                this.diagram = new go.Diagram("tree-protocol",
                    {
                        isReadOnly: true,
                        layout: goMake(go.TreeLayout,
                            {
                                isOngoing: true,
                                isInitial: true,
                                nodeSpacing: 8,
                            }
                        ),
                        "undoManager.isEnabled": true,
                        scale: 1,
                        maxScale: 3,
                        minScale: 0.2,
                        nodeTemplate: goMake(go.Node, "Spot",
                            {
                                selectionObjectName: "PANEL",
                            },
                            new go.Binding('visible', 'data', (data) => {
                                let visible = true;
                                if (data.H == true) {
                                    visible = false;
                                }

                                if (data.display !== undefined && data.display === false) {
                                    visible = false;
                                }

                                return visible;
                            }).ofObject(),
                            makePanel({}, {}, [makeTextBlock()]),
                            makeExpanderButton(),
                        ),
                        linkTemplate: linkTemplate()
                    },
                )
            },
            setModel(data) {
                this.diagram.model = new go.TreeModel(data);
                setCommitNodes(this.diagram, this.Data);
                let hiddenList = [];
                data.forEach(nodeData => {
                    if (nodeData.H === true) {
                        hiddenList.push(nodeData);
                    }
                });
                for (let hiddenNode of hiddenList) {
                    let parentNode = this.diagram.findNodeForKey(hiddenNode.key);
                    let childrenNodes = this.findAllTreeChildrenNodes(parentNode);
                    childrenNodes.map(async (childNode) => {
                        childNode.visible = false;
                    });
                }
            },
            findAllTreeChildrenNodes(node) {
                let children = new go.Set();

                function findChildNodes(currentNode, childrenSet) {
                    if (currentNode) {
                        currentNode.findLinksOutOf().each((link) => {
                            const childNode = link.getOtherNode(currentNode);
                            if (!childrenSet.contains(childNode)) {
                                childrenSet.add(childNode);
                                findChildNodes(childNode, childrenSet);
                            }
                        });
                    }
                }

                findChildNodes(node, children);

                return children;
            },
        }
    }

</script>
<style lang="scss">
    #tree-protocol {
        position: relative;
        background: #fbfbfb;
        height: 700px;
        width: 100%;
    }
</style>